export const arrayToMap = (array, keySelector) => {
    return new Map((array !== null && array !== void 0 ? array : []).map(item => [keySelector(item), item]));
};
//# sourceMappingURL=collection-helpers.js.map